import React, { FC } from 'react';
import moment from 'moment';
import { useTranslations } from '@lang';
import styled from 'styled-components';

const ResetButton = styled.button`
  background: none;
  border: 0;
  text-decoration: underline;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  margin-left: auto;
  padding: 15px 0;
  cursor: pointer;
`;

type ResetDateProps = {
  handleResetDate: ({
    startDate,
    endDate,
  }: {
    startDate: moment.Moment;
    endDate: moment.Moment;
  }) => void;
};

export const ResetDate: FC<ResetDateProps> = ({ handleResetDate }) => {
  const { t } = useTranslations();
  return (
    <ResetButton
      onClick={() => handleResetDate({ startDate: moment(), endDate: moment().add(1, 'days') })}
    >
      {t('common.resetDate')}
    </ResetButton>
  );
};
